<template>
  <div class="share">
    <header>
      <img src="../../assets/images/share-img/icon-24-fanhui.png" alt="" @click="$router.replace('/my')"> 
    </header>
    <section>
      <img src="../../assets/images/share-img/sharebag.png" alt="">
    </section>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="less" scoped>
  .share{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
    }
    section{
      width: 100%;
      height: 100%;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
</style>